import { Directive, HostBinding } from "@angular/core";

/**
 * Marker directive that styles a native `<input type="date">` with the
 * design-system look. Auto-sets `type="date"` so callers can just write
 * `<input bv-date-input>` without remembering the type attribute.
 *
 * Inherits base styling from the same `forms.scss` block as `bv-input`
 * and adds dark-theme tinting for the WebKit calendar-picker-indicator
 * so it stays legible on dark backgrounds.
 *
 *   <bv-form-field label="Date">
 *     <input bv-date-input [(ngModel)]="date" />
 *   </bv-form-field>
 *
 * The bound value is the native `<input type="date">` string format
 * (`"YYYY-MM-DD"`, ISO calendar date). Browsers display the date in the
 * user's locale (US: mm/dd/yyyy, EU: dd/mm/yyyy, etc.) without
 * affecting the bound value.
 */
@Directive({ selector: "input[bv-date-input]" })
export class BvDateInputDirective {
  @HostBinding("attr.type") readonly type = "date";
}
